import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";
const Main = lazy(
  () =>
    import("../../../components/settings/certificate/certificateTemplate/main")
);

const CertificateTemplate = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default CertificateTemplate;
